<div class="d-flex flex-column align-items-center">
  <div class="card col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    
    <h5>{{ text }} Reviewer</h5>

    <div class="d-flex mr-1 justify-content-end">
      <button title="Add Reviewer" class="button-primary" (click)="addReviewer()">
        <mat-icon class="mat-icon-button icon-md" svgIcon="mat:playlist_add" style="color: blue;"></mat-icon>
      </button>
    </div>

    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="saveReviewer()">

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">User</label>
        <ng-select class="form-select" [(ngModel)]="examinationReviewer.user" name="user">
          <ng-option value="" disabled>Select Reviewer</ng-option>
          <ng-option value="" disabled *ngIf="users.length <= 0">No User Found</ng-option>
          <ng-option *ngFor="let usn of users" [value]="usn">{{ usn }}</ng-option>
        </ng-select>
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Examination ID</label>
        <input
          type="number"
          min="0"
          class="form-control"
          [(ngModel)]="examinationReviewer.examinationID"
          name="examinationID"
          disabled>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit">
        Save
      </button>

    </form>
  </div>
</div>